/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BulkStockUpdateRequest } from '../../models/bulk-stock-update-request';
import { BulkStockUpdateResponse } from '../../models/bulk-stock-update-response';

export interface BulkStockUpdate$Params {
      body: BulkStockUpdateRequest
}

export function bulkStockUpdate(http: HttpClient, rootUrl: string, params: BulkStockUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BulkStockUpdateResponse>> {
  const rb = new RequestBuilder(rootUrl, bulkStockUpdate.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BulkStockUpdateResponse>;
    })
  );
}

bulkStockUpdate.PATH = '/stocks/bulk-update';
